import React, { FC, MouseEvent, useRef } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { fc } from 'i18n';
import { TepIntents } from 'constants/tep';
import { ITepEntryPass, ITepLease } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';
import { leasesCellSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface ICellProps {
  entryPass: ITepEntryPass;
}

export const UntilCell: FC<ICellProps> = ({ entryPass }) => {
  const { id, intent } = useSelector(leasesCellSelector);

  const ref = useRef<HTMLDivElement | null>(null);

  const { control, formState } = useFormContext<Partial<ITepLease>>();

  const startOn: Date | undefined = useWatch({ control, name: 'startOn' });

  const error = formState.errors.endOn?.message;

  const isEdit = intent === TepIntents.InlineEdit && entryPass.id === id;
  const endOn = entryPass.lease?.endOn;
  const isExpired = endOn && moment(endOn).isBefore(new Date(), 'day');

  const disabledDate = (date: Date) => moment(date).isBefore(moment(startOn || new Date()), 'day');

  const stopPropagation = (event: MouseEvent) => event.stopPropagation();

  return isEdit ? (
    <Controller
      control={control}
      name="endOn"
      rules={{ required: fc('please select end date') }}
      render={({ value, onChange }) => (
        <div className={styles.datePicker} onClick={stopPropagation}>
          <DatePicker
            placeholder={fc('end date')}
            value={value ? new Date(value) : null}
            onChange={onChange}
            disabledDate={disabledDate}
          />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div ref={ref} style={{ ...(isExpired ? { color: '#C92828' } : {}) }}>
      {endOn ? moment(endOn).format('YYYY-MM-DD') : '-'}
    </div>
  );
};
